import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { TrackersComponent } from './trackers.component';
import { EmptyPageModule } from '../../../empty-page/empty-page.module';
import { AddScorekeeperContentModule } from '../add-scorekeeper-content/add-scorekeeper-content.module';
import { CustomSearchModule } from '../custom-search/custom-search.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
        EmptyPageModule,
        AddScorekeeperContentModule,
        CustomSearchModule
    ],
    exports: [],
    declarations: [TrackersComponent],
    providers: [],
})
export class TrackersModule { }
